import React, { useState, useRef } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { MdAddCircleOutline } from "react-icons/md";
import { crearMalla } from "../../helpers/api.helper";
import { existeDescripcionMalla } from "./mallasUtils";

const CrearMalla = ({ user, fetchMallas, mallas }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [descripcion, setDescripcion] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();
  const toast = useToast();

  const handleClose = () => {
    setDescripcion("");
    onClose();
  };

  const handleSubmit = async () => {
    if (!descripcion.trim()) {
      return toast({
        title: "La descripción es requerida",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    }
    if (existeDescripcionMalla(mallas, descripcion)) {
      return toast({
        title: "Ya existe una malla con esa descripción",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    }
    setLoading(true);
    const res = await crearMalla({
      descripcion: descripcion.trim(),
      usuarioCreate: user.username,
    });
    if (res.success) {
      toast({
        title: "Malla creada correctamente",
        status: "success",
        isClosable: true,
        duration: 3000,
      });
      fetchMallas();
      handleClose();
    } else {
      toast({
        title: "Error al crear malla",
        description: res.message || "Error inesperado",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        border="1px solid #FF8200"
        leftIcon={<MdAddCircleOutline fontSize="20px" />}
        color="brand.naranja"
        onClick={onOpen}
        _hover={{ bg: "brand.naranja", color: "white" }}
      >
        Nueva malla
      </Button>
      <Modal isOpen={isOpen} onClose={handleClose} initialFocusRef={inputRef}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="brand.gris_primario">Nueva Malla</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isRequired>
              <FormLabel fontWeight="bold">Descripción</FormLabel>
              <Input
                ref={inputRef}
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                placeholder="Ingrese la descripción"
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="link" mr={3} onClick={handleClose}>
              Cancelar
            </Button>
            <Button
              bg="brand.naranja"
              color="white"
              isLoading={loading}
              isDisabled={user.idRol === "usuarioIT"}
              onClick={handleSubmit}
            >
              Crear
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CrearMalla;
